import * as angular from 'angular';
import * as moment from 'moment';
import {Strings} from "../shared/config/constant.module";

export interface DatePickerScope extends angular.IScope {
  datePickerDate: moment.Moment;
  datePickerMaxDate: moment.Moment;
  datePickerOnChange: () => ((newDate: Date) => any);
  formattedDate: () => string;
}

export interface ChangeDateEvent extends JQueryEventObject {
  date: Date;
}

export default angular.module('aps.directives.datePicker', [])
  .directive('datePicker', (): angular.IDirective => {
    return {
      scope: {
        datePickerDate: '=',
        datePickerMaxDate: '=',
        datePickerOnChange: '&'
      },
      template: '<a>{{formattedDate()}}</a>',
      link: (scope: DatePickerScope,
             element: mm.foundation.IAugmentedJQuery) => {
        scope.formattedDate = () => scope.datePickerDate.format(Strings.DATE_FORMAT);

        element.fdatepicker({
          endDate: scope.datePickerMaxDate.toDate()
        })
          .on('changeDate', (ev: ChangeDateEvent) => {
            scope.datePickerOnChange()(ev.date);
            element.fdatepicker('hide');
          });

        element.fdatepicker('update', scope.datePickerDate.toDate());

        scope.$watch('datePickerDate', function(){
          element.fdatepicker('update', scope.datePickerDate.toDate());
        });
      }
    };
  })
  .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/directives/date-picker.ts